module.exports = __webpack_public_path__ + "data/roles.json";


//////////////////
// WEBPACK FOOTER
// ./app/services/api/roles/roles.json
// module id = CnML
// module chunks = 1